import React, { useMemo } from 'react'

import PageSection from 'components/common/PageSection'
import { AgentsList } from 'components/configurations/agents/AgentsList'
import { AgentDetailsDrawerProvider } from 'components/configurations/contexts/AgentDetailsDrawerContext'
import { useGetAgentsPaged } from 'queries/agents/use-get-agents-paged'
import { getPageDataItemsFlat } from 'queries/queries-utils'
import { messageFromResponseError } from 'utils/strings'

export const AgentsListContainer: React.FC = () => {
  const {
    data: agents,
    isLoading: isLoadingAgents,
    isError: isErrorAgents,
    error: agentsError
  } = useGetAgentsPaged()

  const agentsList = useMemo(() => getPageDataItemsFlat(agents), [agents])

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        agentsError,
        'We encountered an error while fetching Agents. Please try again later.'
      )}
      hasError={isErrorAgents}
      isLoading={isLoadingAgents}
    >
      <AgentDetailsDrawerProvider agents={agentsList}>
        <AgentsList agents={agentsList} />
      </AgentDetailsDrawerProvider>
    </PageSection>
  )
}
